<template>
    <ReserveRoom />
</template>

<script>
import ReserveRoom from "@/components/ReserveRoom.vue";


export default {
    name: 'ReserveRoomView',
    components: {
        ReserveRoom
    }
}
</script>